<div class="no-access-container">
    <div class="no-access-card">
        <img src="assets/GEA_Logo.png" alt="GEA Logo" class="no-access-logo" />

        <div class="no-access-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
        </div>

        <h1 class="no-access-title">Access Denied</h1>

        <p class="no-access-message">
            You do not have direct access to this application.<br />
           <!--  To access it, please open it through the
            <strong>LPT Engineering Portal</strong>. -->
        </p>

  <!--       <a [href]="portalUrl" target="_blank" rel="noopener noreferrer" class="no-access-button">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                style="margin-right: 8px;">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                <polyline points="15 3 21 3 21 9" />
                <line x1="10" y1="14" x2="21" y2="3" />
            </svg>
            Go to LPT Engineering Portal
        </a>

        <p class="no-access-url">{{ portalUrl }}</p> -->
    </div>
</div>